(() => {
  const STYLE_ID = 'theme-forms-style';
  const css = `
    div[class*="gridItemContent"] > section[class*="formHeader"] {
      margin-block-start: 2.4rem;
    }
    form[data-testid="form"][novalidate] {
      display: grid;
      grid-template-columns: 1fr;
      gap: 1.6rem;
      margin-block-start: 0.5rem;
    }
    form[data-testid="form"][novalidate] > * {
      grid-column: 1 / -1;
      margin: 0;
    }
    form[data-testid="form"][novalidate] > div:has(> input[id="company_name"]),
    form[data-testid="form"][novalidate] > div:has(> input[id="custom#location"]),
    form[data-testid="form"][novalidate] > div:has(> input[id="custom#contact_name"]),
    form[data-testid="form"][novalidate] > div:has(> input[id="email"]) {
      grid-column: auto;
    }
    form[data-testid="form"][novalidate] input[type="text"],
    form[data-testid="form"][novalidate] input[type="email"],
    form[data-testid="form"][novalidate] textarea {
      padding: 1.5rem;
      line-height: 1.3;
    }
    form[data-testid="form"][novalidate] textarea {
      min-height: 10rem;
      resize: vertical;
    }
    form[data-testid="form"][novalidate] label[for] {
      top: 1.5rem;
      transform: none;
      font-size: 1.6rem;
      transition: opacity 0.1s ease-in-out;
    }
    form[data-testid="form"][novalidate] :is(input, textarea):focus ~ label[for],
    form[data-testid="form"][novalidate] input:not(:placeholder-shown) ~ label[for],
    form[data-testid="form"][novalidate] label[for][class*="inputFilled"] {
      opacity: 0;
    }
    form[data-testid="form"][novalidate] label[for="company_name"]::after,
    form[data-testid="form"][novalidate] label[for="custom#contact_name"]::after,
    form[data-testid="form"][novalidate] label[for="email"]::after {
      content: " *";
    }
    form[data-testid="form"][novalidate] fieldset {
      display: grid;
      grid-template-columns: 1fr;
      gap: 1rem;
      margin-block: 0.8rem;
      padding: 0;
      border: 0;
    }
    form[data-testid="form"][novalidate] fieldset > legend {
      padding: 0 0 1.2rem;
      font-weight: 600;
    }
    form[data-testid="form"][novalidate] fieldset label {
      grid-template-columns: 1.6rem 1fr;
      gap: 1rem;
      align-items: center;
      margin: 0;
      cursor: pointer;
    }
    form[data-testid="form"][novalidate] input[type="checkbox"] {
      width: 1.6rem;
      height: 1.6rem;
      margin: 0;
    }
    form[data-testid="form"][novalidate] button[type="submit"] {
      width: auto;
      justify-self: start;
      align-items: center;
      min-height: 4.1rem;
      padding: 0 2rem;
      font-size: 1.3rem;
    }
    @media screen and (min-width: 750px) {
      form[data-testid="form"][novalidate],
      form[data-testid="form"][novalidate] fieldset {
        grid-template-columns: 1fr 1fr;
      }
    }
  `;

  const styleEmbed = (embed) => {
    const root = embed.shadowRoot;
    if (!root || root.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    root.appendChild(style);
  };

  const styleAll = () => document.querySelectorAll('shopify-forms-embed').forEach(styleEmbed);

  const observer = new MutationObserver(styleAll);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  styleAll();
})();
